import { compose } from 'recompose';

import ClientShow from './ClientShow';

const enhance = compose();

export default enhance(ClientShow);
